import Spline from '@splinetool/react-spline'
import { useRef, useEffect, useCallback, Suspense } from 'react'

const SCENE_URL = 'https://prod.spline.design/hllKbcUTPW62qiin/scene.splinecode'

export default function SplineAvatar({ mode }) {
  const splineRef = useRef(null)
  const modeRef = useRef(mode)
  const mouseMoveThrottle = useRef(null)

  function onLoad(spline) {
    splineRef.current = spline
    console.log('✅ Spline cargado. Objetos:', spline.getAllObjects?.()?.map(o => o.name))
  }

  // Sync modeRef so mouse handler always has latest mode
  useEffect(() => { modeRef.current = mode }, [mode])

  // React to mode changes with Spline events
  useEffect(() => {
    if (!splineRef.current) return
    try {
      if (mode === 'speaking')       splineRef.current.emitEvent('mouseDown', 'Avatar')
      else if (mode === 'listening') splineRef.current.emitEvent('mouseHover', 'Avatar')
      else                           splineRef.current.emitEvent('mouseUp', 'Avatar')
    } catch { /* objeto sin ese evento — ok */ }
  }, [mode])

  // Mouse-move handler: avatar "looks" toward the cursor
  const handleMouseMove = useCallback((e) => {
    if (!splineRef.current) return
    // Throttle to ~20fps to avoid flooding Spline
    if (mouseMoveThrottle.current) return
    mouseMoveThrottle.current = setTimeout(() => {
      mouseMoveThrottle.current = null
    }, 50)

    try {
      const { innerWidth, innerHeight } = window
      const nx = (e.clientX / innerWidth)  * 2 - 1  // -1 … +1
      const ny = (e.clientY / innerHeight) * 2 - 1  // -1 … +1

      // Only emit mouse-look events when NOT speaking/listening (don't override mode events)
      if (modeRef.current === 'speaking' || modeRef.current === 'listening') return

      // Divide screen into quadrants and emit different hover events
      if (nx < -0.3) {
        splineRef.current.emitEvent('mouseHover', 'Avatar')
      } else if (nx > 0.3) {
        splineRef.current.emitEvent('mouseHover', 'Avatar')
      } else {
        splineRef.current.emitEvent('mouseUp', 'Avatar')
      }

      // Additionally, move the Spline mouse position so built-in look-at works
      splineRef.current.setVariable?.('mouseX', nx)
      splineRef.current.setVariable?.('mouseY', ny)
    } catch { /* sin evento — ok */ }
  }, [])

  return (
    <Suspense fallback={<Loader />}>
      <div
        style={{ width: '100%', height: '100%' }}
        onMouseMove={handleMouseMove}
      >
        <Spline
          scene={SCENE_URL}
          onLoad={onLoad}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </Suspense>
  )
}

function Loader() {
  return (
    <div style={{
      width: '100%', height: '100%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: '1rem', background: '#06060e',
    }}>
      <div style={{
        width: '48px', height: '48px', borderRadius: '50%',
        border: '2px solid rgba(0,212,255,.15)',
        borderTop: '2px solid #00d4ff',
        animation: 'spin 1s linear infinite',
      }} />
      <p style={{ color: 'rgba(0,212,255,.4)', fontSize: '11px', letterSpacing: '.12em', textTransform: 'uppercase' }}>
        Cargando avatar
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
